
import { defineComponent } from 'vue';
// import { useScriptTag } from '@vueuse/core';
import AppHeader from '@/components/AppHeader.vue';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import DesktopHeader from '@/components/desktop/DesktopHeader.vue';
import DriveAsideMainMenu from '@/modules/drive/components/desktop/DriveAsideMainMenu.vue';

export default defineComponent({
  components: {
    DesktopHeader,
    AppHeader,
    DriveAsideMainMenu,
  },

  setup() {
    const mainStore = useMainStore();
    //
    // const { scriptTag, load, unload } = useScriptTag(
    //   'https://static.zdassets.com/ekr/snippet.js?key=b5b913b4-acef-4c62-9b9e-a58cf599e0ad',
    //   // on script tag loaded.
    //   (el: HTMLScriptElement) => {
    //     const zdChat = document.getElementById('launcher');
    //     if (zdChat !== null) {
    //       zdChat.style.display = 'block';
    //     }
    //   },
    //   {
    //     manual: true,
    //     attrs: { id: 'ze-snippet' },
    //   },
    // );
    // onMounted(async () => {
    //   await load();
    // });
    // onBeforeUnmount(async () => {
    //   const zdChatUnmount = document.getElementById('launcher');
    //   if (zdChatUnmount !== null) {
    //     zdChatUnmount.style.display = 'none';
    //   }
    //   await unload();
    // });
    return {
      mainStore,
    };
  },
});
